// The spec's tabs on a phone (FR-UI-12). The stylesheet keeps the five on
// one row; should a tab's name ever not fit, the strip scrolls sideways
// rather than wrapping, and this brings the current tab into view as the
// page arrives and whenever the window's width changes. Without the bundle
// the strip still scrolls; it only starts at its left end.

// The tab this page is, or, on a page beneath one (a version, a plan's
// review), the tab it is under (FR-UI-16).
const CURRENT = ".spec-nav > [aria-current]";

function showCurrentTab(): void {
  const tab = document.querySelector<HTMLElement>(CURRENT);
  const strip = tab?.parentElement;
  if (!tab || !strip || strip.scrollWidth <= strip.clientWidth) return;
  const box = strip.getBoundingClientRect();
  const at = tab.getBoundingClientRect();
  if (at.left >= box.left && at.right <= box.right) return;
  // Centred where it can be, so the tabs either side of it show too.
  strip.scrollLeft += at.left - box.left - (box.width - at.width) / 2;
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", showCurrentTab);
} else {
  showCurrentTab();
}
window.addEventListener("resize", showCurrentTab);
